import { cloudloyalty } from "../clients";

export const FetchExtractSummary = async (User, finallyCallback = () => {}) => {
    try {
        const response = await cloudloyalty(User).get('/v1/participants/me/extract');
        return response.data;
    } catch (error) {
        console.info('FetchExtractSummary Error =>', error)
    } finally {
        finallyCallback();
    }
};

export const FetchExtractByFilters = async (User, startDate, endDate, finallyCallback = () => {}) => {
    try {
        const response = await cloudloyalty(User).get(`/v1/participants/me/extractOrderDescription?startDate=${startDate}&endDate=${endDate}`);
        return response.data;
    } catch (error) {
        console.info('FetchExtractByFilters Error =>', error)
    } finally {
        finallyCallback();
    }
};

export const FetchExtractToExpire = async (User, finallyCallback = () => {}) => {
    try {
        const response = await cloudloyalty(User).get('/v1/participants/me/toExpire/2');
        return response.data;
    } catch (error) {
        console.info('FetchExtractToExpire Error =>', error)
    } finally {
        finallyCallback();
    }
};
